<template>
  <v-container fluid class="adaptTable">
    <v-layout wrap align-start justify-space-around row fill-height class="hiddeFilters">
      <v-flex v-if="isTecnico" xs12 sm2>
        <v-autocomplete v-model="filters.Cliente" :items="Clientes" :filter="selectFilterIncludes"
                        label="Cliente" item-text="label" item-value="value"
                        class="mx-2" clearable persistent-hint :auto-select-first="true" @input="filter"
        />
      </v-flex>
      <v-flex xs12 sm2>
        <v-autocomplete v-model="filters.Instalacion" :items="loadInstalaciones" :filter="selectFilterIncludes"
                        label="Instalacion" item-text="label" item-value="value"
                        class="mx-2" clearable persistent-hint :auto-select-first="true" @input="filter"
        />
      </v-flex>
      <v-flex xs12 sm2>
        <v-autocomplete v-model="filters.Programa" :items="Programas" label="Programa" item-text="label" item-value="value"
                        class="mx-2" multiple clearable persistent-hint
                        :auto-select-first="true" @input="filter"
        >
          <template v-slot:selection="{ item, index }">
            <span v-if="index === 0" class="ellipsis">
              {{ item.label }}
            </span>
            <span v-if="index === 1" class="body-1">
              &nbsp;( +{{ filters.Programa.length - 1 }} )
            </span>
          </template>
        </v-autocomplete>
      </v-flex>
      <v-flex v-if="isTecnico" xs12 sm2>
        <v-autocomplete v-model="filters.TecnicoAsignado" :items="Tecnicos" :filter="selectFilterIncludes"
                        label="Tecnico Asignado" item-text="label" item-value="value"
                        class="mx-2" multiple chips small-chips clearable persistent-hint
                        :auto-select-first="true" @input="filter"
        >
          <template v-slot:selection="{ item, index }" style="width: 100%">
            <span v-if="index === 0" class="ellipsis">
              {{ item.label }}
            </span>
            <span v-if="index === 1" class="body-1">
              &nbsp;( +{{ filters.TecnicoAsignado.length - 1 }} )
            </span>
          </template>
        </v-autocomplete>
      </v-flex>
      <v-flex xs12 sm2>
        <v-autocomplete v-model="filters.Estado" :items="IncidenciaEstados"
                        label="Estado incidencia" item-text="label" item-value="value"
                        class="mx-2 select-inlin" multiple chips small-chips clearable persistent-hint
                        :auto-select-first="true" @input="filter"
        >
          <template v-slot:selection="{ item, index }">
            <span v-if="index === 0" class="ellipsis">
              {{ item.label }}
            </span>
            <span v-if="index === 1" class="body-1">
              &nbsp;( +{{ filters.Estado.length - 1 }} )
            </span>
          </template>
        </v-autocomplete>
      </v-flex>

      <v-menu v-if="isTecnico" :close-on-content-click="false" nudge-bottom="5" offset-y left attach>
        <template v-slot:activator="{ on }">
          <v-btn color="primary" outline fab small v-on="on">
            <v-icon>settings</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-tile>
            <v-switch v-model="filters.SeguimientoFecha" label="Mostrar con seguimiento" @change="filter" />
          </v-list-tile>
          <v-list-tile>
            <v-switch v-model="filters.DescontarHoras" label="Mostrar Descontar de la bolsa de Horas" @change="filter" />
          </v-list-tile>
          <v-list-tile>
            <v-switch v-model="filters.IncidenciaSinMantenimiento" label="Mostrar Sin Mantenimiento" @change="filter" />
          </v-list-tile>
          <v-list-tile>
            <v-btn color="primary" @click="exportExcel(incidencias)">
              Exporta las Incidencias a Excel
            </v-btn>
          </v-list-tile>
          <v-list-tile class="height-auto-divChild">
            <v-combobox v-model="filters.ReferenciaCliente" label="Referencia Cliente" class="select-inline max-width-300" small-chips multiple
                        clearable
                        @input="filter"
            />
          </v-list-tile>
          <v-list-tile class="height-auto-divChild">
            <v-combobox v-model="filters.Presupuesto" label="Referencia Presupuesto" class="select-inline max-width-300" small-chips multiple
                        clearable
                        @input="filter"
            />
          </v-list-tile>
          <v-list-tile class="height-auto-divChild">
            <v-text-field v-model="filters.Descripcion" label="Buscar por descripción" class="select-inline max-width-300"
                          clearable
                          @input="filter"
            />
          </v-list-tile>
        </v-list>
      </v-menu>

      <v-btn color="primary" outline fab small @click.native="refresh">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </v-layout>
    <v-layout row class="relative-position">
      <v-flex xs12>
        <v-data-table v-model="selected" :headers="columns" :items="incidencias"
                      :pagination.sync="serverPagination" :total-items="total" :rows-per-page-items="rowsPerPageOptions"
                      :loading="loading" select-all item-key="FechaIncidencia" class="elevation-1 tabla-incidencias"
        >
          <template v-slot:headers="props">
            <tr>
              <th style="padding: 0 1px 0 4px !important;">
                <v-checkbox :input-value="!!selected.length" :indeterminate="props.indeterminate" primary hide-details
                            on-icon="mdi-minus" off-icon="mdi-plus" indeterminate-value="mdi-minus-box" style="width: 20px;" @click.native="toggleAll"
                />
              </th>
              <th v-for="header in props.headers" :key="header.text"
                  :class="['column sortable', serverPagination.descending ? 'desc' : 'asc', header.value === serverPagination.sortBy ? 'active' : '']"
                  @click="changeSort(header.value)"
              >
                <v-icon small>
                  arrow_upward
                </v-icon>
                {{ header.text }}
              </th>
              <th v-show="isVisible()" />
            </tr>
          </template>
          <template v-slot:items="props">
            <tr :class="`theme--light cursor-pointer py-2 leida-${props.item.Leida} `">
              <td :class="`status ${getColor(props.item, false)}`" style="width:15px; padding:0 !important; border-width: 0 1px 1px 0;">
                <v-icon :color="getColor(props.item, false, true)"
                        light :style="`font-size:1.5em`" class="mx-1"
                >
                  {{ getIcons(props.item)[0] }}
                </v-icon>
                <router-link :to="loadIncidencia(props.item, true)" :event="null" tabindex="-1" @click.native.stop="clickIncidencia(props, $event)" />
              </td>
              <td key="Instalacion" :class="`non-selectable ${getColor(props.item, true)}`" style="max-width: 150px">
                <div class="ellipsis">
                  {{ findLabel('instalacion', `${props.item.Cliente}/${props.item.Instalacion}`) }}
                </div>
                <router-link :to="loadIncidencia(props.item, true)" :event="null" @click.native.stop="clickIncidencia(props, $event)" />
              </td>
              <td key="Incidencia" :class="`non-selectable ${getColor(props.item, true)}`">
                {{ props.item.Cliente }}/{{ props.item.Instalacion }}/{{ props.item.Incidencia }}
                <router-link :to="loadIncidencia(props.item, true)" :event="null" tabindex="-1" @click.native.stop="clickIncidencia(props, $event)" />
              </td>
              <td key="FechaIncidencia" :class="`non-selectable ${getColor(props.item, true)}`">
                {{ formatDate(props.item.FechaIncidencia) }}
                <router-link :to="loadIncidencia(props.item, true)" :event="null" tabindex="-1" @click.native.stop="clickIncidencia(props, $event)" />
              </td>
              <td key="Programa" :class="`non-selectable ${getColor(props.item, true)}`" style="max-width: 100px">
                <div class="ellipsis">
                  {{ findLabel("programa", props.item.Programa) }}
                </div>
                <router-link :to="loadIncidencia(props.item, true)" :event="null" tabindex="-1" @click.native.stop="clickIncidencia(props, $event)" />
              </td>
              <td key="TecnicoAsignado" :class="`non-selectable ${getColor(props.item, true)}`">
                <div class="ellipsis">
                  {{ findLabel('tecnico', props.item.TecnicoAsignado) }}
                </div>
                <router-link :to="loadIncidencia(props.item, true)" :event="null" tabindex="-1" @click.native.stop="clickIncidencia(props, $event)" />
              </td>
              <!-- <td key="refCliente" :props="props">{{ props.item.ReferenciaIncidenciaCliente }}</td> -->
              <td v-if="isVisible()" class="pa-0">
                <div style="width: 154px" />
              </td>
              <td v-show="props.item.SeguimientoFecha || props.item.AnclaFecha || isVisible(props)"
                  :class="`text-center sticky-column px-0 hiddeBottons ${getColor(props.item, true)}`"
              >
                <div class="row width-100p height-100p px-1">
                  <v-tooltip v-if="isTecnico" bottom>
                    <template v-slot:activator="{ on }">
                      <span v-show="props.item.SeguimientoFecha || isVisible(props)" class="action width-100p height-100p" v-on="on">
                        <v-btn :color="props.item.SeguimientoFecha ? 'primary': getColor(props.item, false, true)" light flat
                               icon class="ma-0"
                               @click.stop="seguirIncidencia(props.item)"
                        >
                          <v-icon>{{ props.item.SeguimientoFecha ? 'mdi-eye-off': 'mdi-eye' }}</v-icon>
                        </v-btn>
                      </span>
                    </template>
                    <span>{{ props.item.SeguimientoFecha ? 'Desmarcar como seguimiento': 'Marcar como seguimiento' }}</span>
                  </v-tooltip>
                  <v-tooltip v-if="isTecnico" bottom>
                    <template v-slot:activator="{ on }">
                      <span v-show="props.item.AnclaFecha || isVisible(props)" class="action width-100p height-100p" v-on="on">
                        <v-btn :color="props.item.AnclaFecha ? 'primary': getColor(props.item, false, true)" light flat
                               icon class="ma-0" @click.stop="anclarIncidencia(props.item)"
                        >
                          <v-icon>{{ props.item.AnclaFecha ? 'mdi-pin-off': 'mdi-pin' }}</v-icon>
                        </v-btn>
                      </span>
                    </template>
                    <span>{{ props.item.AnclaFecha ? 'Desanclar': 'Anclar' }}</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-show="isVisible(props)" class="action width-100p height-100p" v-on="on">
                        <v-btn :color="getColor(props.item, false, true)" light flat
                               icon class="ma-0" @click.stop="loadIncidencia(props.item)"
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </span>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>
                  <v-tooltip v-if="isTecnico" bottom>
                    <template v-slot:activator="{ on }">
                      <span v-show="props.item.Estado !== 'A' && props.item.Estado !== 'C' && isVisible(props)" class="action width-100p height-100p" v-on="on">
                        <v-btn :color="getColor(props.item, false, true)" light
                               flat icon class="ma-0" @click.stop="showTransfer(null, props.item)"
                        >
                          <v-icon>mdi-forward</v-icon>
                        </v-btn>
                      </span>
                    </template>
                    <span>Traspasar</span>
                  </v-tooltip>
                </div>
              </td>
            </tr>
            <tr v-show="props.selected" :class="$vuetify.dark ? 'grey darken-2' : 'grey lighten-4'" class="v-datatable__expand-row">
              <td colspan="100%">
                <!-- <div v-if=" getIcons(props.item).length > 1">
                  <v-icon v-for="icon in getIcons(props.item, true)" :key="`${icon}${props.item.Cliente}${props.item.Instalacion}${props.item.Incidencia}`"
                          :color="getColor(props.item, false, true)" light :style="`font-size:1.5em`" class="mx-1"
                  >
                    {{ icon }}
                  </v-icon>
                </div> -->
                <div class="text-left ml-2 my-2">
                  <div class="description">
                    <div style="white-space: normal !important;">
                      Cliente: {{ findLabel('cliente', props.item.Cliente) }}&emsp;
                      ReportadaPor: {{ props.item.ReportadaPor }}&emsp;
                      Tipo: {{ findLabel('tipoIncidencia', props.item.TipoIncidencia) }}&emsp;
                      RefCliente: {{ props.item.ReferenciaIncidenciaCliente }}&emsp;
                      Prioridad: {{ findLabel('prioridad', props.item.Prioridad) }}&emsp;
                      RecibidaPor: {{ findLabel('tecnico', props.item.TecnicoRecepcion) }}&emsp;
                      FechaCierre: {{ formatDate(props.item.FechaCierreIncidencia) }}&emsp;
                      TiempoEmpleado: {{ props.item.TiempoEmpleado }}&emsp;
                    </div>
                    <div class="body-2 my-2">
                      <chips-drive
                        :ref="`chipsDrive${props.item.Cliente}-${props.item.Instalacion}-${props.item.Incidencia}`"
                        :cliente="props.item.Cliente"
                        :instalacion="props.item.Instalacion"
                        :incidencia="props.item.Incidencia"
                      />
                    </div>
                    <div>
                      <div class="body-2 my-2">
                        Descripcion
                      </div>
                      <span v-html="props.item.Descripcion" />
                    </div>
                    <div v-if="props.item.Observaciones && isTecnico">
                      <div class="body-2 my-2">
                        Observaciones
                      </div>
                      <span v-html="props.item.Observaciones" />
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
      <inner-loading :visible="loading" />
    </v-layout>
  </v-container>
</template>

<script>
/* eslint-disable */
import InnerLoading from '@/components/InnerLoading'
import { Entities, Forms } from 'mixins/index.js'
import { EventBus } from '@/store/EventBus.js'
import Transfer from './transfer.vue'
import moment from 'moment'
import ChipsDrive from '@/components/ChipsDrive'
import Vue from 'vue'
//import JsonCSV from 'vue-json-csv'

//Vue.component('downloadCsv', JsonCSV)

export default {
  name: 'Incidencias',
  components: { InnerLoading, ChipsDrive },
  mixins: [Entities, Forms],
  data () {
    return {
      profile: this.$store.getters['getProfile'],
      isTecnico: false,
      serverPagination: { initial: true,
        page: 1,
        rowsPerPage: 100,
        sortBy: 'FechaIncidencia',
        descending: true },
      total: 5,
      rowsPerPageOptions: [20, 50, 100, 150, 200],
      columns: [
        { text: 'Instalacion', value: 'Instalacion', sortable: true, align: 'left' },
        { text: 'Incidencia', value: 'Incidencia', sortable: true, align: 'left' },
        { text: 'Fecha petición', value: 'FechaIncidencia', sortable: true, align: 'left' },
        { text: 'Programa', value: 'Programa', sortable: true, align: 'left' },
        { text: 'Tecnico Asignado', value: 'TecnicoAsignado', sortable: true, align: 'left' }
      ],
      showByIndex: null,
      showByIndexTimer: null,
      selected: [],
      incidencias: [],
      cliente: 0,
      instalacion: 0,
      incidencia: 0,
      loading: false,
      time: null,
      clicks: { count: 0, timer: null },
      filters: {
        Cliente: null,
        Instalacion: null,
        TecnicoAsignado: [],
        Estado: [],
        Programa: [],
        ReferenciaCliente: [],
        Presupuesto: [],
        SeguimientoFecha: false,
        DescontarHoras: null,
        IncidenciaSinMantenimiento: null,
        FechaProximoAviso: Date.now(),
        Descripcion: null
      }
    }
  },
  metaInfo: { title: `Incidencias - Sopheo` },
  computed: {
    loadInstalaciones () {
      if (this.filters.Cliente) { return this.filterBy('instalacion', `${this.filters.Cliente}/`) } else { return this.Instalaciones }
    }
  },
  watch: {
    'filters.Cliente': function (value) {
      if (this.loadInstalaciones.length === 1) { this.filters.Instalacion = this.loadInstalaciones[0].value }
      if (!value) { this.filters.Instalacion = null }
    },
    'filters.Instalacion': function (value) {
      this.loadProgramas()
      if (value) this.filters.Cliente = parseInt(value.split('/')[0])
    },
    serverPagination: {
      handler (value) {
        if (!value.initial) { this.request() }
      },
      deep: true
    }
  },
  created () {
    EventBus.$on('reloadRequest', this.request)
    EventBus.$emit('newToolbarTitle', {
      template: `<span>Incidencias</span>`
    })
  },
  mounted () {
    if (!this.$route.query.back) { this.initialLoad(true) }
    this.getRol();
  },
  beforeDestroy () {
    EventBus.$off('reloadRequest', this.request)
  },
  onActive () {
    this.request()
  },
  methods: {
    getRol: function () {
      if (this.profile.Role === 'Tecnico') {
        this.isTecnico = true
      }
    },
    handleMouse (props) {
      this.showByIndex = props ? props.index : ''
      /*
       `${incidencia.Cliente}/${incidencia.Instalacion}/${incidencia.Incidencia}`
        if (this.showByIndexTimer) clearTimeout(this.showByIndexTimer)
      this.showByIndexTimer = setTimeout(() => {
        this.$nextTick(() => {
        })
      }, 100) */
    },
    isVisible (props) {
      // `${props.item.Cliente}/${props.item.Instalacion}/${props.item.Incidencia}`
      // console.log(props)
      return this.$vuetify.breakpoint.smAndDown || (props && props.selected)
    },
    loadProgramas () {
      if (this.filters.Cliente && this.filters.Instalacion && this.filters.Instalacion.split('/').pop()) {
        this.getProgramaBy(this.filters.Cliente, this.filters.Instalacion.split('/').pop())
      } else { this.asyncProgramas() }
    },
    filter () {
      if (this.time) clearTimeout(this.time)
      this.time = setTimeout(() => {
        this.serverPagination.initial = false
        if (this.serverPagination.page === 1) { this.request() }
        this.serverPagination.page = 1
      }, 1500)
    },
    exportExcel (arrayOfJson) {
      // convert JSON to CSV
      const replacer = (key, value) => value === null ? '' : value // specify how you want to handle null values here
      const header = Object.keys(arrayOfJson[0])
      let csv = arrayOfJson.map(row => header.map(fieldName =>
        JSON.stringify(row[fieldName], replacer)).join(','))
      csv.unshift(header.join(','))
      csv = csv.join('\r\n')

      // Create link and download
      var link = document.createElement('a')
      link.setAttribute('href', 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(csv))
      link.setAttribute('download', 'incidencias.csv')
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    loadIncidencia (incidencia, getHref = false) {
      if (getHref) {
        let routeData = this.$router.resolve({ name: 'incidenciasEdit',
          params: { clienteProp: incidencia.Cliente, instalacionProp: incidencia.Instalacion, incidenciaProp: incidencia.Incidencia }
        })
        return routeData.resolved.fullPath
      } else {
        this.$router.push({ name: 'incidenciasEdit',
          params: { clienteProp: incidencia.Cliente, instalacionProp: incidencia.Instalacion, incidenciaProp: incidencia.Incidencia }
        })
      }
    },
    async initialLoad (getSession) {
      this.loading = true
      this.incidencias = window.sessionStorage.getItem('incidencias') ? JSON.parse(window.sessionStorage.getItem('incidencias')) : []
      setTimeout(() => {
        this.asyncClientes()
        this.asyncInstalaciones()
        this.asyncIncidenciaEstados()
        this.asyncProgramas()
        this.asyncTecnicos()
      }, 10)

      setTimeout(() => {
        if (getSession) {
          this.filters.Cliente = Number(window.sessionStorage.getItem('Cliente')) || null
          this.filters.Instalacion = window.sessionStorage.getItem('Instalacion') || null
          this.filters.SeguimientoFecha = window.sessionStorage.getItem('SeguimientoFecha') === 'true'
          this.filters.DescontarHoras = window.sessionStorage.getItem('DescontarHoras') === 'true'
          this.filters.IncidenciaSinMantenimiento = window.sessionStorage.getItem('IncidenciaSinMantenimiento') === 'true'
          this.filters.Estado =
            window.sessionStorage.getItem('Estado') ? JSON.parse(window.sessionStorage.getItem('Estado')) : null
          this.filters.TecnicoAsignado =
            window.sessionStorage.getItem('TecnicoAsignado') ? JSON.parse(window.sessionStorage.getItem('TecnicoAsignado')) : null
          this.filters.Programa =
            window.sessionStorage.getItem('Programa') ? JSON.parse(window.sessionStorage.getItem('Programa')) : null
          this.filters.ReferenciaCliente =
            window.sessionStorage.getItem('ReferenciaCliente') ? JSON.parse(window.sessionStorage.getItem('ReferenciaCliente')) : null
          this.filters.Presupuesto =
            window.sessionStorage.getItem('Presupuesto') ? JSON.parse(window.sessionStorage.getItem('Presupuesto')) : null
          this.filters.Descripcion =
            window.sessionStorage.getItem('Descripcion') ? JSON.parse(window.sessionStorage.getItem('Descripcion')) : null
        } else {
          this.filters.Cliente = null
          this.filters.Instalacion = null
          this.filters.Estado = null
          this.filters.TecnicoAsignado = null
          this.filters.Programa = []
          this.filters.ReferenciaCliente = []
          this.filters.Presupuesto = []
          this.filters.SeguimientoFecha = false
          this.filters.DescontarHoras = null
          this.filters.IncidenciaSinMantenimiento = null
          this.filters.Descripcion = null
        }
        if (!this.filters.TecnicoAsignado) {
          this.filters.TecnicoAsignado = []
          if (this.$store.getters['getTecnico']) {
            this.filters.TecnicoAsignado.push(this.$store.getters['getTecnico'])
            this.filters.TecnicoAsignado.push(0)
          }
        }

        if (!this.filters.Estado) {
          this.filters.Estado = []
          this.filters.Estado.push('N')
          this.filters.Estado.push('P')
          this.filters.Estado.push('U')
        }
        if (!this.filters.Cliente && this.$store.getters['getClient']) { this.filters.Cliente = this.$store.getters['getClient'] }
        if (!this.filters.Instalacion && this.$store.getters['getInstallation']) { this.filters.Instalacion = this.$store.getters['getInstallation'] }
        // if (!this.filters.Instalacion.length && this.$store.getters['getInstallation']) { this.filters.Instalacion.push(this.$store.getters['getInstallation']) }
        // this.request({ pagination: this.serverPagination })
        if (getSession && window.sessionStorage.getItem('serverPagination')) this.serverPagination = JSON.parse(window.sessionStorage.getItem('serverPagination'))
        else {
          this.serverPagination = {
            page: 1,
            rowsPerPage: 100,
            sortBy: 'FechaIncidencia',
            descending: true
          }
        }

        setTimeout(() => {
          this.serverPagination.initial = false
        }, 50)
      }, 5)
    },
    request () {
      this.loading = true
      let filas = `?rows=${this.serverPagination.rowsPerPage}`
      let pagina = `&page=${this.serverPagination.page}`

      let query = ''
      if (this.filters) {
        if (this.filters.FechaProximoAviso) {
          this.filters.FechaProximoAviso = moment(this.filters.FechaProximoAviso).format('YYYY-MM-DD')
        }
        Object.keys(this.filters).forEach((field) => {
          if (Array.isArray(this.filters[field])) {
            window.sessionStorage.setItem(field, JSON.stringify(this.filters[field]))
            this.filters[field].forEach((element) => {
              if (field === 'Instalacion') { query += `&${field}=${element.split('/').pop()}` } else { query += `&${field}=${element}` }
            })
          } else if (typeof this.filters[field] === 'boolean') {
            window.sessionStorage.setItem(field, this.filters[field])
            if ((field === 'SeguimientoFecha' || field === 'DescontarHoras' || field === 'IncidenciaSinMantenimiento') &&
             this.filters[field]) {
              query += `&${field}=${this.filters[field]}`
            }
          } else {
            window.sessionStorage.setItem(field, this.filters[field] || '')
            if (this.filters[field]) {
              if (field === 'Instalacion') {
                query += `&${field}=${this.filters[field].split('/').pop()}`
              } else { query += `&${field}=${this.filters[field]}` }
            }
          }
        })
      }
      let sortBy = this.serverPagination.sortBy ? `&sortBy=${this.serverPagination.sortBy}&descending=${this.serverPagination.descending}` : ''
      this.axios
        .get(this.$apiUrl('incidencia') + filas + pagina + query + sortBy, {
          headers: { 'Content-Type': 'application/json' }
        })
        .then(({ data }) => {
          this.total = data.recordsFiltered
          this.incidencias = data.data || []
          window.sessionStorage.setItem('incidencias', JSON.stringify(this.incidencias))
          window.sessionStorage.setItem('serverPagination', JSON.stringify(this.serverPagination))
        })
        .catch(() => { })
        .then(() => { this.loading = false })
    },
    getIcons (incidencia, removeFirst) {
      let icons = []
      let icon = 'mdi-'
      if (incidencia.Presupuesto) icons.push(`${icon}currency-eur`)
      // else if (incidencia.Estado === 'C') icons.push(`${icon}lock`)
      if (incidencia.DescontarHoras) icons.push(`${icon}clock-alert-outline`)
      if (incidencia.IncidenciaSinMantenimiento) icons.push(`${icon}alert-outline`)

      if (removeFirst && icons.length > 1) icons = icons.shift()
      return icons
    },
    showTransfer (TecnicoAsignado, { Cliente, Instalacion, Incidencia, Observaciones }) {
      EventBus.$emit('showModal', { component: Transfer, props: { componentProps: { TecnicoAsignado, Cliente, Instalacion, Incidencia, Observaciones } } })
    },
    anclarIncidencia (incidencia) {
      if (incidencia.Cliente && incidencia.Instalacion && incidencia.Incidencia) {
        let anclar = `?cliente=${incidencia.Cliente}&instalacion=${incidencia.Instalacion}&incidencia=${incidencia.Incidencia}`
        anclar += `&anclar=${!incidencia.AnclaFecha}`
        this.axios.get(this.$apiUrl('anclarIncidencia') + anclar, { headers: { 'Content-Type': 'application/json' } })
          .then(({ data }) => {
            if (data) {
              incidencia.AnclaFecha = data.AnclaFecha
              this.$notify({ message: `Incidencia ${incidencia.AnclaFecha ? 'anclada' : 'desanclada'}.`, type: 'info' })
            }
          })
      }
    },
    seguirIncidencia (incidencia) {
      if (incidencia.Cliente && incidencia.Instalacion && incidencia.Incidencia) {
        let seguir = `?cliente=${incidencia.Cliente}&instalacion=${incidencia.Instalacion}&incidencia=${incidencia.Incidencia}`
        seguir += `&seguir=${!incidencia.SeguimientoFecha}`
        this.axios.get(this.$apiUrl('seguirIncidencia') + seguir, { headers: { 'Content-Type': 'application/json' } })
          .then(({ data }) => {
            if (data) {
              incidencia.SeguimientoFecha = data.SeguimientoFecha
              this.$notify({ message: `Incidencia ${incidencia.SeguimientoFecha ? 'marcada' : 'desmarcada'} como seguimiento.`, type: 'info' })
              if (this.filters.SeguimientoFecha) {
                setTimeout(() => {
                  if (this.filters.SeguimientoFecha) {
                    let index = this.incidencias.indexOf(incidencia)
                    if (index > -1 && !this.incidencias[index].SeguimientoFecha) this.incidencias.splice(index, 1)
                  }
                }, 60000)
              }
            }
          })
      }
    },
    toggleAll () {
      if (this.selected.length) this.selected = []
      else this.selected = this.incidencias.slice()
      for (let z = 0; z < this.selected.length; z++) {
        this.$refs[`chipsDrive${this.selected[z].Cliente}-${this.selected[z].Instalacion}-${this.selected[z].Incidencia}`].loadFiles()
      }
      this.selected.splice()
    },
    changeSort (column) {
      if (this.serverPagination.sortBy === column) {
        this.serverPagination.descending = !this.serverPagination.descending
      } else {
        this.serverPagination.sortBy = column
        this.serverPagination.descending = false
      }
    },
    clickIncidencia (incidencia, event) {
      this.clicks.count++
      if (this.clicks.count === 1) {
        incidencia.selected = !incidencia.selected
        this.cliente = incidencia.item.Cliente
        this.instalacion = incidencia.item.Instalacion
        this.incidencia = incidencia.item.Incidencia
        this.$refs[`chipsDrive${incidencia.item.Cliente}-${incidencia.item.Instalacion}-${incidencia.item.Incidencia}`].loadFiles()
        this.clicks.timer = setTimeout(() => {
          this.clicks.count = 0
        }, 250)
      } else {
        this.loading = true
        this.clicks.count = 0
        clearTimeout(this.clicks.timer)
        this.loadIncidencia(incidencia.item)
      }
    },
    refresh (event) {
      this.clicks.count++
      if (this.clicks.count === 1) {
        this.clicks.timer = setTimeout(() => {
          this.initialLoad(true)
          this.clicks.count = 0
        }, 250)
      } else {
        clearTimeout(this.clicks.timer)
        this.initialLoad(false)
        this.clicks.count = 0
      }
    },
    previewImage ($event) {
      this.$refs.chipsDrive.previewImage($event)
    }
  }
}
</script>

<style >
@media print {
  .hiddeBottons {
    display: none;
  }
  .hiddeFilters {
    display: none;
  }
  .adaptTable {
    margin-top: -9%;
    padding-right: 0%;
    padding-left: 0%;
  }
}
</style>
